import { Type, Validator } from "./Type";
import { TextFieldFactory } from "./TextFieldFactory";
import { JsonComponent } from "../components/Inputs/JsonComponent";
import { TextFieldComponent } from "..";

// component usage example : TextField({autoComplete:"off",type:"password"},Required,Length(2,5)...); TextField({props}, ...Validators)
export const TextField = (...args: any[]) => {
  return TextFieldFactory(...args);
};

export const LongTextField = (...args: any[]) => {
  return TextFieldFactory({ multiline: true, rows: 3 }, ...args);
};

export const Json = (jsonProps?: any, ...validators: Validator[]) =>
  new Type({
    Component: TextFieldComponent,
    PresentationComponent: JsonComponent as any,
    props: {
      jsonProps
    },
    validators
  });

export const PasswordField = (...args: any[]) => {
  return TextFieldFactory({ type: "password" }, ...args);
};
